<script setup>
defineProps({
  active: {
    type: Boolean,
    required: true,
    default: true,
  },
  label: {
    type: String,
    required: false,
    default: '',
  },
});
</script>

<template>
  <div
    v-if="active"
    class="loading-container d-flex flex-column justify-content-center align-items-center position-fixed fixed-top w-100 h-100"
    style="background-color: rgba(255, 255, 255, 0.8); z-index: 9999"
  >
    <div class="spinner-border mb-2" role="status" style="color: #3abbc6">
      <span class="visually-hidden">Loading...</span>
    </div>
    <div v-if="label" class="mt-2 text-center" style="color: #3abbc6; font-weight: 500">
      {{ label }}
    </div>
  </div>
</template>

<style lang="scss" scoped></style>
